'use es6';

export const QUEUE_ACCESS_TYPE_PRIVATE = 'PRIVATE';
export const QUEUE_ACCESS_TYPE_SHARED = 'SHARED';